<template>
    <div class="positions-page">
        <app-sub-title text="Cargos" />
        <div class="positions-page-buttons">
            <button class="btn btn-primary" @click="openForm">
                <i class="fa fa-plus"></i> Crear Cargo
            </button>
        </div>
        <app-positions-filters
            v-if="!!positions"
            :onFilter="onFilter"
            :onClearFilters="onClearFilters"
            :options="positions"
        />
        <app-positions-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="onDelete"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="position-form"
            :title="!position ? 'Crear Cargo' : 'Editar Cargo'"
            :on-close="() => $bus.$emit('position-form.clear')"
        >
            <div slot="body">
                <app-position-form
                    :selected-position="position"
                    :on-save="onSave"
                    id="position-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-primary"
                    :disabled="inProgress"
                    @click="savePosition"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import positionsRepository from "../../../repositories/positions.repository";
import SubTitle from "../../UI/Layout/SubTitle.vue";
import PositionsList from "./PositionsList/PositionsList.vue";
import PositionsFilters from "./PositionsFilters/PositionsFilters.vue";
import PositionForm from "./PositionsForm/PositionForm.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        appSubTitle: SubTitle,
        appPositionsList: PositionsList,
        appPositionsFilters: PositionsFilters,
        appPositionForm: PositionForm
    },
    data() {
        return {
            data: {},
            page: 1,
            filters: {},
            position: null,
            sort: {
                sortBy: "positions.name",
                sortDir: "asc"
            }
        };
    },
    computed: {
        ...mapGetters(["positions"])
    },
    methods: {
        loadPositions() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir
            };
            positionsRepository
                .getPaged(this.page, filters)
                .then(data => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al cargar los cargos");
                });
        },
        onChangePage(page) {
            this.page = page;
            this.loadPositions();
        },
        onEdit(position) {
            this.position = position;
            this.openForm();
        },
        onDelete(position) {
            const pr = { ...positionsRepository };

            pr.deletePosition(position.id)
                .then(data => {
                    if (!!data.status) {
                        this.loadPositions();
                        toastr.warning("El cargo ha sido eliminado");
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al eliminar el cargo");
                });
        },
        onFilter(filters) {
            this.page = 1;
            this.filters = filters;
            this.loadPositions();
        },
        onClearFilters() {
            this.page = 1;
            this.filters = null;
            this.loadPositions();
        },
        savePosition() {
            this.$bus.$emit("position-form.save");
        },
        onSave() {
            this.closeForm();
            this.loadPositions();
        },
        openForm() {
            this.$bus.$emit("position-form.open");
        },
        closeForm() {
            this.$bus.$emit("position-form.close");
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadPositions();
        }
    },
    created() {
        this.loadPositions();
        this.load("positions");
    }
};
</script>
